export type MatchLocalesOptions = {
  browserLocales: string[];
  supportedLocales: string[];
  defaultLocale: string;
};

export function matchLocales(options: MatchLocalesOptions): string[] {
  const browser = options.browserLocales.map((l) => l.toLowerCase());
  const supported = options.supportedLocales.map((l) => l.toLowerCase());
  const fallback = options.defaultLocale.toLowerCase();

  const matched: string[] = [];

  for (const locale of browser) {
    const base = locale.split('-')[0];

    // 1. Exact match
    if (supported.includes(locale) && !matched.includes(locale)) {
      matched.push(locale);
      continue;
    }

    // 2. Base match (e.g., 'fr' -> 'fr-CA' or 'fr')
    const baseMatch = supported.find((l) => l === base || l.startsWith(base + '-'));
    if (baseMatch && !matched.includes(baseMatch)) {
      matched.push(baseMatch);
      continue;
    }

    // 3. Reverse base match (e.g., app has 'fr-CA', browser has 'fr')
    const reverseMatch = supported.find((l) => l.split('-')[0] === base);
    if (reverseMatch && !matched.includes(reverseMatch)) {
      matched.push(reverseMatch);
    }
  }

  if (matched.length === 0) {
    matched.push(fallback);
  }

  return matched;
}
